/* Ballast Supply — cart-drawer upsells (Primitive Labs–style). Add-to-cart + hide-when-in-cart. Defensive. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function renderDrawer() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        try {
          if (s['cart-drawer']) {
            var d = document.querySelector('cart-drawer');
            var nn = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
            if (d && nn) { d.innerHTML = nn.innerHTML; d.classList.toggle('is-empty', nn.classList.contains('is-empty')); }
          }
          if (s['cart-icon-bubble']) {
            var b = document.getElementById('cart-icon-bubble');
            var nb = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble');
            if (b && nb) b.innerHTML = nb.innerHTML;
          }
        } catch (e) {}
        syncVisibility();
      }).catch(function () {});
  }

  // hide any upsell card whose product is already in the cart; hide the block if all gone
  function syncVisibility() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ids = (cart.items || []).map(function (i) { return String(i.variant_id); });
        document.querySelectorAll('[data-pl-upsell]').forEach(function (el) {
          el.style.display = ids.indexOf(el.getAttribute('data-variant')) > -1 ? 'none' : '';
        });
        document.querySelectorAll('[data-pl-upsells]').forEach(function (bl) {
          var visible = [].slice.call(bl.querySelectorAll('[data-pl-upsell]')).some(function (e) { return e.style.display !== 'none'; });
          bl.style.display = visible ? '' : 'none';
        });
      }).catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.pl-upsell__add');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    if (!id) return;
    btn.disabled = true; btn.classList.add('loading');
    var onCartPage = !!document.getElementById('main-cart-items');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () {
      if (onCartPage) { window.location.reload(); return; }
      return renderDrawer();
    }).catch(function () {})
      .then(function () { if (!onCartPage) { btn.disabled = false; btn.classList.remove('loading'); } });
  });

  // re-sync after any drawer re-render (debounced)
  try {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(syncVisibility, 200); })
      .observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
  if (document.readyState !== 'loading') syncVisibility(); else document.addEventListener('DOMContentLoaded', syncVisibility);
})();
